import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";


const createReview = async (payload: any)=>{
    const { data } = await axios.post(Apis.CREATE_REVIEWS, payload, { headers: { Authorization: getToken() } });
    return data;
}

export default createReview;